'use client';

import SecondaryTag from "../../Tags/SecondaryTag.jsx";
import { StyledButton } from "../../Buttons/StyledButton.jsx";

const img1 = "/assets/numbers/01.svg";
const img2 = "/assets/numbers/02.svg";
const img3 = "/assets/numbers/03.svg";
const img4 = "/assets/numbers/04.svg";
function WhyCUs() {
  return (
    <div className="mx-4 sm:mx-16 mt-32">
      <div className="flex flex-col items-center gap-2 ">
        <SecondaryTag text={"Why choose us?"} />
        <div className="w-[300px] md:w-[656px] text-color-1 text-center text-4xl lg:text-[56px] font-medium leading-[normal] ">
          <span>Digital Command Center</span>
          <br />
          <span>- The Difference</span>
        </div>
      </div>

      <Nums />

      <div className="flex justify-center items-center gap-8 mt-12">
        <StyledButton
          text="Sign Up"
          onClick={() => {
            window.open("https://digitalcommandcenter.io/signup", "_blank");
          }}
        />
      </div>

      <div className="absolute top-48 -left-80 rounded-full w-[500px] h-[500px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10"></div>
      <div className="absolute top-48 -right-80 rounded-full w-[500px] h-[500px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10"></div>
    </div>
  );
}

export default WhyCUs;

const Nums = () => (
  <div className="flex justify-around flex-wrap gap-12 pt-16">
    {[
      {
        img: img1,
        title: "Integrated Solution",
        classes: "",
        description: "Combines HR, CRM, and ERP in one platform.",
      },
      {
        img: img2,
        title: "Customizable Modules",
        classes: "",
        description: "We tailor the platform to your specific needs.",
      },
      {
        img: img3,
        title: " Transparent Billing",
        classes: "",
        description: "Clear pricing and package management.",
      },
      {
        img: img4,
        title: "Multilingual Support",
        classes: "",
        description: "Fully compatible with international audiences.",
      },
    ].map((item, index) => (
      <div
        key={index}
        className="flex flex-col items-center text-center gap-4 w-64 group relative "
      >
        <div className="absolute -top-10 left-16 rounded-3xl w-[20px] -rotate-45 h-[250px] transition-all duration-700 bg-[radial-gradient(circle,_var(--neutral-bg),_var(--accent-light))] blur-3xl opacity-35 group-hover:opacity-65"></div>

        <img
          src={item.img}
          className={`w-32 h-32 md:w-36 md:h-36 ${item.classes} transition-all duration-700 opacity-100 z-10`}
          alt="image"
        />
        <h3 className="text-color-1 text-2xl font-semibold -mt-7 z-20">
          {item.title}
        </h3>
        <p className="text-color-2">{item.description}</p>
      </div>
    ))}
  </div>
);
